import { AuthProvider } from "@mattfinkel/common-web";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./index.css";
import App from "./App";
import { auth } from "./firebase";
import { api } from "./lib/api";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider auth={auth} api={api}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
